export var publishedArticlesInfo = {
    items: [
        {
            logoImg: "/img/news/plant-service.png",
            type: "Projects",
            date: "03 Feb 2025",
            header: "New Roofing Technology Breakthrough",
            shortText: "A groundbreaking solar-integrated roofing system debuts, offering a 30% boost in energy efficiency.",
            url: "https://www.plantservices.com/home/article/11345088/look-before-it-leaks"
        },
        {
            logoImg: "/img/news/roofing-constructor-logo.png",
            type: "Inovations",
            date: "03 Feb 2025",
            header: "Façade Innovation Award Winner",
            shortText: "Renowned architect receives prestigious award innovative sustainable façade design in urban development.",
            url: "https://www.roofingcontractor.com/articles/84709-create-winning-sales-proposals"
        },
        {
            logoImg: "/img/news/pushing-the-envelope-logo.png",
            type: "Company News",
            date: "03 Feb 2025",
            header: "Smart Paving Solutions Launch",
            shortText: "A new intelligent paving technology has been introduced to improve urban infrastructure monitoring.",
            url: "https://bsao.ca/sites/default/uploads/files/newsletter/Fall-2017-articles/Pushing_the_Envelope_Fall2017-article5.pdf#search=%22Steven%20James%22"
        }
    ]
}